import React from "react";

interface SettingsTitleProps {
  title: string;
  subtitle?: string;
}

const SettingsTitle = ({ title, subtitle }: SettingsTitleProps) => {
  return (
    <div className="space-y-2">
      <h2 className="text-2xl font-bold">{title}</h2>
      {subtitle && <p className="text-sm text-light-secondary-text-color">{subtitle}</p>}
    </div>
  );
};

export default SettingsTitle;
